export const stylePresetModalNormalFlow = {
    title: 'Are you sure?',
    description: 'Changing your style will reset your customizations.',
    firstButtonText: 'Change style',
    secondButtonText: 'Cancel',
}

export const stylePresetModalCustomizeFlow = {
    title: 'Choose a specific style',
    description: 'Choosing a specific style will remove your current selections',
    firstButtonText: 'Change style',
    secondButtonText: 'Cancel',
}